export const PASSWORD_POLICY_RULES = [
  {
    key: "length",
    label: "Mindestens 8 Zeichen",
    message: "Mindestens 8 Zeichen",
    test: (password = "") => password.length >= 8,
  },
  {
    key: "uppercase",
    label: "Mindestens ein Großbuchstabe (A-Z)",
    message: "Mindestens ein Großbuchstabe (A-Z)",
    test: (password = "") => /[A-Z]/.test(password),
  },
  {
    key: "lowercase",
    label: "Mindestens ein Kleinbuchstabe (a-z)",
    message: "Mindestens ein Kleinbuchstabe (a-z)",
    test: (password = "") => /[a-z]/.test(password),
  },
  {
    key: "number",
    label: "Mindestens eine Zahl (0-9)",
    message: "Mindestens eine Zahl (0-9)",
    test: (password = "") => /\d/.test(password),
  },
  {
    key: "special",
    label: "Mindestens ein Sonderzeichen (!@#$...)",
    message: "Mindestens ein Sonderzeichen (!@#$...)",
    test: (password = "") =>
      /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password),
  },
];

export const PASSWORD_POLICY_MESSAGE =
  "Bitte wählen Sie ein Passwort mit mindestens 8 Zeichen sowie Groß-/Kleinbuchstaben, Zahl und Sonderzeichen.";

export const getPasswordPolicyChecks = (password = "") => {
  return Object.fromEntries(
    PASSWORD_POLICY_RULES.map(({ key, test }) => [key, test(password)]),
  );
};

export const getFailedPasswordPolicyMessages = (password = "") => {
  return PASSWORD_POLICY_RULES.filter(({ test }) => !test(password)).map(
    ({ message }) => message,
  );
};

export const isPasswordPolicyValid = (password = "") => {
  return getFailedPasswordPolicyMessages(password).length === 0;
};
